const ROLE = { "top pick": "Top pick", danger: "Danger", roughie: "Roughie" };

export const TipPrice = ({ s, testid }) => (!s.price && !s.role ? null : (
  <span className="inline-flex items-center gap-1.5 text-[11px] text-slate-400 whitespace-nowrap" data-testid={testid}>
    {s.role && <span className={s.role === "roughie" ? "text-fuchsia-300" : "text-blue-300"}>{ROLE[s.role]}</span>}
    {s.price ? <span className="font-mono text-amber-300" title={`Best price when tipped${s.price_source ? ` (${s.price_source})` : ""}. Prices change, check with your bookmaker.`}>${Number(s.price).toFixed(2)}</span> : null}
  </span>
));
